"use client";

import { cn } from "@repo/ui/lib/utils";
import { useEffect, useRef, useState } from "react";
import { useTranslations } from "next-intl";

export default function ProductDescription({
  features,
}: {
  features: string[];
}) {
  const t = useTranslations("Product");
  const descriptionRef = useRef<HTMLDivElement>(null);
  const [descriptionReadMore, setDescriptionReadMore] = useState(false);
  const [showReadMore, setShowReadMore] = useState(false);

  useEffect(() => {
    if (descriptionRef.current) {
      const computed = getComputedStyle(descriptionRef.current);
      const lineHeight = parseFloat(computed.lineHeight || "0");
      const maxLines = 6;
      const maxHeight = lineHeight * maxLines;

      if (descriptionRef.current.scrollHeight > maxHeight) {
        setShowReadMore(true);
      }
    }
  }, []);

  return (
    <>
      <div
        ref={descriptionRef}
        className={cn(
          `leading-6 mt-8 max-md:text-sm whitespace-pre-line line-clamp-6`,
          { "line-clamp-0": descriptionReadMore },
        )}
      >
        {features?.length &&
          features
            ?.filter((feat: string) => !!feat)
            .map((f, i) => (
              <p
                key={i}
                className="list-disc list-inside"
                style={{ display: "list-item" }}
              >
                {f}
              </p>
            ))}
      </div>
      {showReadMore && (
        <a
          onClick={() => setDescriptionReadMore(!descriptionReadMore)}
          className="block underline font-bold max-md:text-sm cursor-pointer mt-2"
        >
          {descriptionReadMore ? t("read-less") : t("read-more")}
        </a>
      )}
    </>
  );
}
